export const ENDPOINT_SLOTS = '/slots';
export const ENDPOINT_FIRST_MONTH = '/slots/first-month';
export const ENDPOINT_APPOINTMENT_TYPES = '/slots/appointment-types';
export const ENDPOINT_APPOINTMENT_PRACTITIONERS = '/slots/practitioners';
export const ENDPOINT_BRANDING = '/branding';
export const ENDPOINT_BOOKING = '/booking';
export const ENDPOINT_LOCK_SLOT = '/lock-slot';
export const ENDPOINT_SEND_VERIFICATION_TEXT = '/send-verification-text';
export const ENDPOINT_VERIFY_TEXT_CODE = '/verify-text-code';
export const ENDPOINT_PATIENT = '/existing-patient';
export const ENDPOINT_PAYMENT = '/payments';
export const ENDPOINT_DEPOSITS = '/deposits';